<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="sociedades"
	[displayWith]="displaySociedad"
	[value]="selectedSociedad"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
